import React, { useContext, useEffect } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { AdContext } from './AdContext';
import ddt from '@wix/da-ddt';
/**
 * Init is used to init the clientside ads
 */ const AdInit = ()=>{
    const { adsEnabled  } = useContext(SessionContext);
    const { DaAds  } = useContext(AdContext);
    useEffect(()=>{
        if (adsEnabled && DaAds) {
            const providers = window.__ADPROV__;
            if (providers.length === 0) {
                ddt.alert('ads', 'Ads init with no active providers this is bad!', [
                    'ads',
                    'fatal'
                ], {});
                return;
            }
            DaAds.init(providers, window.__ADUNITS__ || []);
        }
    // We only want this to run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
AdInit.displayName = 'AdInit';
export default AdInit;
